module.exports = __webpack_public_path__ + "static/media/Forms.0fc3781a.svg";